module.exports = {
  title: '审批模版',
  route: {
    path: '/crm-system',
    children: {
      path: 'crm-approval-template',
    },
  },
};
